import React, { ReactElement, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { AdminPermissionsSystemValues, ApplicationPermissionsSystemValues } from '@fluentsms/types-fluent';
import { useAuth } from '../auth';

export type AuthorizedRouteProps = {
  children: ReactNode;
  redirectUrl: string;
  authorizationTarget: AdminPermissionsSystemValues | ApplicationPermissionsSystemValues;
  tenantOrgEntityId?: string;
  isApplicationPermissions?: boolean;
};

export const AuthorizedRoute = ({
  children,
  authorizationTarget,
  redirectUrl,
  tenantOrgEntityId,
  isApplicationPermissions = false,
}: AuthorizedRouteProps): ReactElement => {
  const { isAuthorized, hasAuthorizedAnywhere } = useAuth();
  const { pathname } = useLocation();

  const isUserAuthorized = isApplicationPermissions
    ? hasAuthorizedAnywhere(authorizationTarget)
    : isAuthorized(authorizationTarget, tenantOrgEntityId);

  if (isUserAuthorized) {
    return <>{children}</>;
  }

  const searchParams = pathname !== '/' ? `?${new URLSearchParams({ from: pathname }).toString()}` : '';
  return <Navigate to={`${redirectUrl}${searchParams}`} replace />;
};

export default AuthorizedRoute;
